/**
 * Константы и настройки приложения (02_GPT-MODULAR).
 * URL API, feature flags — здесь или в .env.
 */

export const APP_NAME = "Новий сайт";

const rawApiUrl = process.env.REACT_APP_API_URL || "";
export const API_BASE_URL = (rawApiUrl.includes(":3002") ? "/api" : rawApiUrl || "/api").replace(/\/$/, "");

